import { Button } from "@component/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@component/dialog";
import { AlertTriangle } from "lucide-react";

interface Props {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

export default function UploadCVWarningDialog(props: Props) {
    return (
        <Dialog open={props.isOpen} onOpenChange={props.onClose}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <DialogTitle className="flex items-center gap-2">
                        <div className="w-8 h-8 rounded-full bg-yellow-100 dark:bg-yellow-900/30 flex items-center justify-center">
                            <AlertTriangle className="h-5 w-5 text-yellow-500 dark:text-yellow-400" />
                        </div>
                        Upload your CV
                    </DialogTitle>
                    <DialogDescription
                        className="pt-4 space-y-3 text-sm"
                        style={{ paddingBottom: "16px" }}
                    >
                        <p>You can upload your CV once for this application.</p>
                        <p>Uploading a new CV will replace your existing profile.</p>
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter className="flex-row gap-2 sm:gap-2">
                    <Button
                        variant="outline"
                        onClick={props.onClose}
                        className="flex-1"
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={props.onConfirm}
                        className="flex-1 bg-blue-600 hover:bg-blue-700 text-white"
                    >
                        Upload CV
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}